<template>
  <section>
    <a class="mod-avatar" href="javascript:void(0);" v-for="(item, index) in value">
      <div class="avatar-inner">
        <i class="el-icon-zoom-in" @click="preview(item, index)"></i>
        <i class="el-icon-delete" @click="del(item, index)"></i>
      </div>
      <div class="img-box">
        <img :src="item">
      </div>
    </a>
    <el-upload :action="actionStr" list-type="picture-card" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :file-list="fileList" :limit="limitNum" :class="classStr" :accept="accept" :data="uploadData" :on-error="error" :disabled="$attrs['disabled']" :show-file-list="false">
      <i class="el-icon-plus"></i>
      <p class="mod-tips" slot="tip"><slot name="tips"/></p>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" ref="dialog" @closed="closed">
      <img width="100%" :src="dialogImageUrl" alt="" style="max-width: 1000px; margin: 0 auto; display:block;">
    </el-dialog>
  </section>
</template>
<script>
  export default {
    name: 'mc-upload',
    props: ['value', 'limit', 'action', 'size', 'imageUrl'],
    model: {
      prop: 'value',
      event: 'update'
    },
    data () {
      return {
        uploadData: {
          uploadType: '0',
          systemName: 'newProductApplication',
          fileUrl: '',
          name: ''
        },
        baseURL: window.IPConfig.HOST ? (window.IPConfig.IP + ':' + window.IPConfig.HOST) : window.IPConfig.IP,
        fileList: [],
        loaded: false,
        dialogImageUrl: '',
        dialogVisible: false
      }
    },
    computed: {
      accept () {
        return this.$attrs['accept'] || 'image/gif, image/jpeg, image/png, image/bmp'
      },
      actionStr () {
        let str = this.action || (this.$config && this.$config.uploadUrl ? this.$config.uploadUrl : '/contentmanagement/uploadFiles')
        str = this.baseURL + str
        return str
      },
      limitNum () {
        return this.limit || 10000000
      },
      classStr () {
        if (this.limitNum && this.value && this.value.length !== 0) {
          if (this.value.length >= Number(this.limitNum)) {
            return 'mod-limit'
          }
        }
        return ''
      }
    },
    watch: {
      value () {
        if (!this.loaded) {
          this.setValue()
        }
      }
    },
    methods: {
      del (item, index) {
        let ar = [...this.value];
        ar.splice(index, 1);
        this.$emit('update', ar)
      },
      preview (item, index) {
        this.dialogImageUrl = item
        this.dialogVisible = true
      },
      error () {
        this.$message.error('上传失败，请重新上传')
      },
      handleAvatarSuccess (res, file, fileList) {
        if (res && (res.code == 200 && res.msg == 'success')) {
          let ar = this.value || []
          let ar2 = [].concat(ar)
          let imageUrl = this.baseURL + '/contentmanagement/download/' + res.resultMap[0].saveFileUrl
          ar.push({url: imageUrl, name: file.name})
          ar2.push(imageUrl)
          this.loaded = true
          this.$emit('update', ar2)
          this.$emit('change', ar)
        }
      },
      beforeAvatarUpload (file) {
        this.uploadData.name = file.name
        let sizeVal = this.size || 3
        const size = file.size / 1024 / 1024
        const isLt2M = (size < sizeVal || size == sizeVal)
        if (!isLt2M) {
          this.$message.error(`上传图片大小不能超过 ${sizeVal}M!`)
        }
        return isLt2M
      },
      setValue () {
        this.fileList = []
        if (this.value && this.value.length > 0) {
          this.value.forEach(item => {
            this.fileList.push({url: item.url || item})
          })
        }
      },
      closed () {
        this.dialogVisible = false
      }
    },
    mounted () {
      this.setValue()
    }
  }
</script>
<style lang="scss" scoped>
  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  /deep/ .el-upload-list--picture-card {
    .el-upload-list__item {
      float:left;
      width: 100px;
      height: 100px;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-box;
      display: box;
      -webkit-box-align: center;
      -moz-box-align: center;
      -ms-box-align: center;
      box-align: center;
      -webkit-box-pack: center;
      -moz-box-pack: center;
      -ms-box-pack: center;
      box-pack: center;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
      }
    }
    .el-upload-list__item-thumbnail {
      width: auto;
      height: auto;
      max-width: 100px;
      max-height: 100px;
    }
    .el-upload-list__item-actions span+span {
      // margin-left: 0px;
    }
  }
  .mod-tips {
    line-height: normal;
    font-size: 12px;
    color: #999;
    padding-top: 5px;
  }
  .mod-limit /deep/.el-upload--picture-card {
    display: none;
  }
  .mod-avatar {
    width: 100px;
    height: 100px;
    position: relative;
    display: block;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    &:hover {
      .avatar-inner {
        display: block;
      }
    }
    .avatar-inner {
      position: absolute;
      height: 100%;
      width: 100%;
      text-align: center;
      line-height: 100px;
      display: none;
      &:after {
        content: '';
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background: #000;
        opacity: 0.3;
        border-radius: 4px;
      }
      i {
        font-size:18px;
        color: #fff;
        position: relative;
        z-index: 1;
      }
      .el-icon-delete {
        margin-left: 5px;
      }
    }
    .img-box {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-box;
      display: box;
      -webkit-box-align: center;
      -moz-box-align: center;
      -ms-box-align: center;
      box-align: center;
      -webkit-box-pack: center;
      -moz-box-pack: center;
      -ms-box-pack: center;
      box-pack: center;
      height: 100%;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mc-ui/upload/index.vue